/**
 * we create the following format: 2024-05-04 (4th of May, 2024)
 */
export function getFormattedDateForTask(): string {
  return new Date().toISOString().split('T')[0];
}
